import React from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import { Flex, Table, Tbody, Td, Th, Thead, Tr, Text } from "@chakra-ui/react";

export const TableEducacao = ({ data, columns, saude, frequentaEscola }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,

    prepareRow,

    page,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: 4,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect
  );
  if (frequentaEscola === "N") {
    delete columns[1];
    delete columns[2];
  }
  return (
    <Flex flexDir="column" overflowX="auto" mt={!saude && "5"}>
      <Table {...getTableProps} backgroundColor="white">
        <Thead>
          {saude ? (
            ""
          ) : (
            <Tr>
              <Th
                backgroundColor="#ECEFF1"
                colSpan={columns.length}
                border="1px solid #D7D8DE"
              >
                <Flex gap={1}>
                  <Text fontSize="11.5px" color="#169499">
                    Unidade Escolar (Histórico)
                  </Text>
                </Flex>
              </Th>
            </Tr>
          )}

          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  border="1px solid #D7D8DE"
                  bgColor={saude && "#ECEFF1"}
                  borderLeft={
                    column.Header === "Escola Atual" ||
                    column.Header === "Laudo Médico" ||
                    column.Header === "Faz Algum Tratamento de Saúde?" ||
                    column.Header === "Comprovante de Matrícula Escolar"
                      ? "none"
                      : ""
                  }
                  borderRight={
                    frequentaEscola === "N"
                      ? "1px solid #D7D8DE"
                      : column.Header === "Nome" ||
                        column.Header === "Faz Algum Tratamento de Saúde?" ||
                        column.Header === "Problema de Saúde" ||
                        column.Header === "Escola Atual"
                      ? "none"
                      : ""
                  }
                  color={"#000"}
                  {...column.getHeaderProps({
                    ...column.getHeaderProps(
                      !(column.Header === "Opções") &&
                        column.getSortByToggleProps({ title: undefined })
                    ),
                  })}
                  key={index}
                  whiteSpace={{
                    md: "normal",
                    lg:
                      column.Header === "Comprovante de Matrícula Escolar"
                        ? "nowrap"
                        : "normal",
                  }}
                >
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent={
                      column.Header === "Opções" ||
                      column.Header === "Laudo Médico" ||
                      column.Header === "Faz Algum Tratamento de Saúde?"
                        ? "center"
                        : "flex-start"
                    }
                  >
                    <Text as="p">{column.render("Header")}</Text>
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  if (
                    cell.column.Header === "Comprovante de Matrícula Escolar"
                  ) {
                    return (
                      <Td
                        key={index}
                        {...cell.getCellProps()}
                        py="6px"
                        fontWeight={500}
                        fontSize="14px"
                        lineHeight="21.6px"
                        border="1px solid #D7D8DE"
                        borderLeft="none"
                        color="#797A80"
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  } else {
                    return (
                      <Td
                        key={index}
                        {...cell.getCellProps()}
                        py="6px"
                        fontWeight={500}
                        w={"70%"}
                        fontSize="14px"
                        lineHeight="21.6px"
                        width={saude && "33%"}
                        border="1px solid #D7D8DE"
                        borderLeft={
                          ((saude &&
                            (cell.column.Header === "Laudo Médico" ||
                              cell.column.Header ===
                                "Faz Algum Tratamento de Saúde?")) ||
                            cell.column.Header === "Escola Atual") &&
                          "none"
                        }
                        borderRight={
                          frequentaEscola === "N"
                            ? "1px solid #D7D8DE"
                            : saude
                            ? cell.column.Header ===
                                "Faz Algum Tratamento de Saúde?" ||
                              cell.column.Header === "Problema de Saúde"
                              ? "none"
                              : ""
                            : "none"
                        }
                        color="#797A80"
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  }
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Flex>
  );
};
